import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { Cutting, CuttingRequest, CuttingTemplate, CuttingTemplateRequest, OrderEntry } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { ConverterService } from '../../../../core/util';
import { CUTTING_NORMALIZER } from './converters';

@Injectable({
  providedIn: 'root',
})
export class CartEntryCuttingConnector {
  constructor(
    private httpClient: HttpClient,
    private occEndpointsService: OccEndpointsService,
    private converterService: ConverterService
  ) {}

  add(userId: string, cartId: string, entry: OrderEntry, cutting: CuttingRequest): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryCutting', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.put(url, cutting);
  }

  remove(userId: string, cartId: string, entry: OrderEntry): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryCutting', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.delete(url);
  }

  calculatePrice(userId: string, cartId: string, entry: OrderEntry, cutting: CuttingRequest): Observable<Cutting> {
    const url = this.occEndpointsService.buildUrl('cartEntryCuttingPrice', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
      queryParams: {
        daughterWidth: cutting.daughterWidth,
        daughterLength: cutting.daughterLength,
        dustFree: cutting.dustFree,
        perpendicular: cutting.perpendicular,
        daughterGrainDirection: cutting.daughterGrainDirection,
        numberOfDaughters: cutting.numberOfDaughters,
        numberOfCuts: cutting.numberOfCuts,
        templateCode: cutting.templateCode,
        packagingCode: cutting.packagingCode,
      },
    });
    return this.httpClient.get<Occ.Cutting>(url).pipe(this.converterService.pipeable(CUTTING_NORMALIZER));
  }

  calculateTemplate(
    userId: string,
    cartId: string,
    entry: OrderEntry,
    cutting: CuttingTemplateRequest
  ): Observable<CuttingTemplate> {
    const url = this.occEndpointsService.buildUrl('cartEntryCuttingTemplate', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
      queryParams: {
        daughterWidth: cutting.daughterWidth,
        daughterLength: cutting.daughterLength,
        dustFree: cutting.dustFree,
        perpendicular: cutting.perpendicular,
      },
    });
    return this.httpClient.get<Occ.CuttingTemplate>(url);
  }
}
